module.exports = __webpack_public_path__ + "static/media/post-update-2.467d63a4.svg";